export enum ExportCatalogType  {
     None = 'None', //0
     Offers = 'Offers',//1,
     Tree = 'Tree',//2,
     OffersAndTree = 'OffersAndTree'//3,
}